import { html } from 'lit';
import '../../../components/score';
import { t } from 'i18next';
import { formatDate } from '../../../utils/date';
import { isEmpty } from '../../../utils/stringUtils';
export const Feedback = (me, other, profileUrl, feedbackGiven) => {
    const user = feedbackGiven || isEmpty(me.name)
        ? html `<p class="m-0 inline-block caption strong">
          ${feedbackGiven ? t('You') : t('Anonumous user')}
        </p>`
        : html `<a
          class="caption strong m-0 inline-block text-link no-underline hover:underline"
          href="${profileUrl}"
        >
          ${other.name}
        </a>`;
    const participant = feedbackGiven ? me : other;
    if (participant.feedback === null) {
        return html `
      ${user}
      ${participant.hasGivenFeedback
            ? t('has deleted the comment')
            : t('has not written a comment')}
    `;
    }
    const hasTextFeedback = !isEmpty(participant.feedback.textReview);
    return html `
    <div
      class="p-16 bg-surface-secondary border-[1px] border-bluegray rounded-8"
    >
      <div class="flex justify-between">
        <div class="flex">
          <trust-score score="${participant.feedback.score}"></trust-score>
          <div>
            ${user}
            <p class="detail">
              ${participant.role === 'SELLER' ? t('Seller') : t('Buyer')}
            </p>
          </div>
        </div>
        <p class="caption">${formatDate(participant.feedback.givenAt)}</p>
      </div>
      <div class="mt-16 ${!hasTextFeedback ? 'text-secondary' : ''}">
        ${hasTextFeedback ? participant.feedback.textReview : t('No comment')}
      </div>
    </div>
  `;
};
//# sourceMappingURL=Feedback.js.map